<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <OccurencesForm :baseOccurence="occurence" :baseOccurenceName="name" :loading="loading" :requestOccurence="requestOccurence" @submit-requested="submitRequested"></OccurencesForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import OccurencesForm from './OccurencesForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            occurence: null,
            name: this.$route.params.name,
            loading: true,
            requestOccurence: true
        }
    },
    components: { OccurencesForm },
    computed:
    {
        ...mapState('occurences', ['getOccurenceDetailsOutput']),
    },
    methods: {
        ...mapActions('occurences', ['getOccurenceDetails']),
        ...mapActions('occurences', ['putOccurence']),
        submitRequested(occurence) {
            this.putOccurence(occurence);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'OccurencesList' });
        }
        if(this.requestOccurence) {
            this.getOccurenceDetails(this.$route.query.id)
        }
    },
    watch:
    {
        getOccurenceDetailsOutput: function(occurenceOutput)
        {
            if(!occurenceOutput && !occurenceOutput.data)
            {
                router.push({ name: 'OccurencesList' });
            }
            else
            {
                this.occurence = occurenceOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>